if (!customElements.get('main-product-header')) {
  customElements.define(
    'main-product-header',
    class MainProductHeader extends HTMLElement {
      constructor() {
        super()
      }
      menuItems = [
        "#menu-item-product-features",
        "#menu-item-product-len-spec",
        "#menu-item-product-frame-spec",
        "#menu-item-product-review"
      ]

      menuItemsMapWithEl = [
        "#product-features",
        ".vlt-chart-section",
        "#technical-drawing-section",
        "#product-reviews"
      ]

      changeProductImgs(sources) {

        this.getElementsByClassName
        const container = this.getElementsByClassName("mainproduct-header-img-container").item(0);
        while (container.firstChild) {
          container.removeChild(container.lastChild);
        }
        for (let index = 0; index < sources.length; index++) {
          const element = sources[index];
          const imgEl = document.createElement("img")
          imgEl.classList.add("layer", "layer-frame")
          imgEl.src = element;
          container.appendChild(imgEl)
        }
      }
      scrollEvt = this.onScroll.bind(this);
      connectedCallback() {
        document.addEventListener("scroll", this.scrollEvt)

        for (let index = 0; index < this.menuItems.length; index++) {
          const menuSelector = this.menuItems[index];
          const elementSelector = this.menuItemsMapWithEl[index];
          if ($(elementSelector).length == 0) {
            $(menuSelector).remove()
          } else {
            $(menuSelector).on("click", function () {
              $('html, body').scrollTop($(elementSelector).offset().top - 100);
            });
          }

        }

        if (this.dataset.imgs) {
          try {
            this.changeProductImgs(JSON.parse(this.dataset.imgs))
          } catch (error) {
          }
        }
        setTimeout(() => {
          this.onScroll()

        }, 100);
      }

      disconnectedCallback() {
        document.addEventListener("scroll", this.scrollEvt)

      }


      isInViewport(el) {
        if (el.length > 0) {
          var elementTop = el.offset().top;
          var elementBottom = elementTop + el.outerHeight();
          var viewportTop = $(window).scrollTop();
          var viewportBottom = viewportTop + $(window).height();
          return elementBottom > viewportTop && elementTop < viewportBottom;
        }
        return false;
      };

      onScroll() {

        if (document.documentElement.scrollTop >= 1500) {
          document.getElementById("main-product-header").classList.remove("hide")
        } else {
          document.getElementById("main-product-header").classList.add("hide")
        }
        let activeMenu;
        for (let index = 0; index < this.menuItems.length; index++) {
          const menuSelector = this.menuItems[index];
          const elementSelector = this.menuItemsMapWithEl[index];

          if (!activeMenu && this.isInViewport($(elementSelector))) {
            activeMenu = menuSelector;
          }
          $(menuSelector).removeClass("active")

        }
        if (activeMenu) {
          $(activeMenu).addClass("active")
        }

        // var dim = $('#tech-spec').is(":visible");


        // console.log("sdfasdf", document.documentElement.scrollTop);
      }

    }
  )
}



